import { FastField, Formik } from "formik";
import React from "react";
import {
  Button,
  Container,
  Form,
  Grid,
  Pagination,
  Segment,
  Table,
  Checkbox,
  Label,
} from "semantic-ui-react";
import moment from "moment";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { useEventGroup } from "Hooks/Endpoints";
import { EventGroupListView } from "callable-data-objects";
import EventDetailView from "./EventDetailView";
import DatePicker from "Components/Shared/DatePicker";
import useCheckRole from "Hooks/APICheckRole";
import { isEmpty } from "lodash";

const EventsView = () => {
  const { hasRole, roles } = useCheckRole();
  const { filter, onFilter, events, event, select } = useEventGroup();

  const getContent = () => {
    return events.content || [];
  };

  const getActivePage = (activePage: string | number | undefined) => {
    return activePage && typeof activePage === "number" ? activePage - 1 : 0;
  };

  if (event) {
    return <EventDetailView />;
  }

  return (
    <Grid padded stackable>
      <Grid.Column width={4}>
        <Segment>
          <Formik
            validateOnChange={false}
            initialValues={filter}
            onSubmit={(values, actions) => {
              onFilter(values);
            }}
          >
            {({ handleSubmit, errors }) => (
              <Form onSubmit={handleSubmit}>
                <DatePicker name='date' label='Date' />

                <FastField name='cli' label='CLI' component={CallableInput} />

                <FastField
                  name='extension'
                  label='Extension(s)'
                  component={CallableInput}
                />

                <FastField
                  name='tag'
                  label='Tag(s)'
                  component={CallableInput}
                />

                <FormSubmit name='Filter' errors={errors} />
              </Form>
            )}
          </Formik>
        </Segment>
      </Grid.Column>

      <Grid.Column width={12}>
        <Table stackable celled compact size='small'>
          <Table.Header>
            <Table.Row>
              <Table.Cell>ID</Table.Cell>
              <Table.Cell>Date</Table.Cell>
              <Table.Cell>From</Table.Cell>
              <Table.Cell>To</Table.Cell>
              <Table.Cell>Server</Table.Cell>
              <Table.Cell>Region</Table.Cell>
              <Table.Cell>Duration</Table.Cell>
              <Table.Cell>In</Table.Cell>
              <Table.Cell>Out</Table.Cell>
              <Table.Cell>PBX</Table.Cell>
              {/* <Table.Cell>Billable?</Table.Cell> */}
              <Table.Cell>Recorded?</Table.Cell>
              {hasRole(roles.account.events.roles.select) && (
                <Table.Cell>Actions</Table.Cell>
              )}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {getContent()
              .filter((ev: EventGroupListView) => ev !== null)
              .map((ev: EventGroupListView) => (
                <Table.Row key={`event-${ev.id}`}>
                  <Table.Cell>{ev.id}</Table.Cell>
                  <Table.Cell>{moment(ev.created).format("YYYY-MM-DD HH:mm:ss")}</Table.Cell>
                  <Table.Cell>{ev.from}</Table.Cell>
                  <Table.Cell>{ev.to}</Table.Cell>
                  <Table.Cell>{ev.server}</Table.Cell>
                  <Table.Cell>{ev.region}</Table.Cell>
                  <Table.Cell>{ev.duration}</Table.Cell>
                  <Table.Cell>{ev.alegStatus}</Table.Cell>
                  <Table.Cell>{ev.blegStatus}</Table.Cell>
                  <Table.Cell>
                    {ev.extensions?.map((s:String) => (
                      <Label>{s}</Label>
                    ))}
                  </Table.Cell>
                  {/* <Table.Cell>
                  <Checkbox toggle checked={ev.cdrCount > 0} />
                </Table.Cell> */}
                  <Table.Cell>
                    <Checkbox toggle checked={ev.recordingCount > 0} />
                  </Table.Cell>
                  {hasRole(roles.account.events.roles.select) && (
                    <Table.Cell>
                      <Button primary onClick={() => select(ev)}>
                        View
                      </Button>
                    </Table.Cell>
                  )}
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
        <Container fluid textAlign='right'>
          {events.content && (
            <Pagination
              defaultActivePage={events.number + 1}
              totalPages={events.totalPages}
              onPageChange={(event, { activePage }) =>
                onFilter({
                  ...filter,
                  page: getActivePage(activePage),
                })
              }
            />
          )}
        </Container>
      </Grid.Column>
    </Grid>
  );
};

export default EventsView;
